module.exports = __webpack_public_path__ + "assets/images/scrolly-ageing/mobile.svg?v=e8b8f781";